// @flow
export const getFormattedLockboxCode = (value: string) => String(value).replace(/\D/g, '').substring(0, 4);

export const formatLockboxCode = (
  lockboxCodeString: string,
) => getFormattedLockboxCode(lockboxCodeString);

export default formatLockboxCode;
